import { Button } from 'components/button';
import { Icon, IconsEnum } from 'components/Icons';
import { TableFieldProps } from 'components/mieScommesseTableRow/MieScommesseTableRow';
import { StateField } from 'components/mieScommesseTableRow/stateField/StateField';
import { TableField } from 'components/mieScommesseTableRow/tableField/TableField';
import styles from './MieScommesseTableRowMobile.module.scss';

export type MieScommesseTableRowMobileProps = {
  columns: TableFieldProps[];
  onClick?: () => void | undefined;
  internalClassName?: string;
};

export const MieScommesseTableRowMobile = ({
  columns,
  onClick,
  internalClassName,
}: MieScommesseTableRowMobileProps) => {
  const tableTitle = columns.find((column) => column.component === TableField);
  const stateField = columns.find((column) => column.component === StateField);

  return (
    <div className={`${styles.container} ${internalClassName ? styles[internalClassName] : ''}`}>
      <div className={styles.header}>
        <div className={styles.flexHeader}>
          {tableTitle && tableTitle.component ? <tableTitle.component {...tableTitle.props} /> : null}
        </div>
        <div className={styles.flex}>
          {stateField && stateField.component ? <stateField.component {...stateField.props} /> : null}
          <Button className={styles.iconContainer} onClick={onClick}>
            <Icon iconId={IconsEnum.CHEVRON_RIGHT} className={styles.arrowIcon} color="var(--color-primary)" />
          </Button>
        </div>
      </div>
      <div className={styles.grid}>
        {columns.slice(1).map((column, i) => {
          if (column.component !== StateField) {
            return column?.component && <column.component {...column.props} key={i} />;
          } else return null;
        })}
      </div>
    </div>
  );
};
